import { useEffect, useState } from 'react'
import Search from './Search'
import { SlideHeader } from './SlideHeader'
import FilterSelectedOnly from './FilterSelectedOnly'
import { useSelector } from 'react-redux'
import { wait } from 'utils/helpers'
import { useDispatch } from 'react-redux'
import { setContinueDisabled } from 'store/CustomReports/actions'
import { setSingleCourseGroup } from 'store/CustomReports/actions'
import { setMultipleCourseGroups } from 'store/CustomReports/actions'
import { setAllCourseGroups } from 'store/CustomReports/actions'

function SelectSingleOrMultipleCourseGroups({ title, multiple }) {
  const dispatch = useDispatch()
  const [searchValue, setSearchValue] = useState('')
  const [filteredCourseGroups, setFilteredCourseGroups] = useState([])

  const {
    allCourseGroups,
    selectedSingleCourseGroup,
    showSelectedOnly,
    selectedMultipleCourseGroups,
  } = useSelector((store) => store.customReports)

  console.log(allCourseGroups, selectedSingleCourseGroup, 'leart25')

  useEffect(() => {
    dispatch(setAllCourseGroups())
  }, [dispatch])

  useEffect(() => {
    if (allCourseGroups && allCourseGroups.length) {
      setFilteredCourseGroups(
        allCourseGroups.filter((course) =>
          course.name.toLowerCase().includes(searchValue.trim().toLowerCase())
        )
      )
    }
  }, [allCourseGroups, searchValue])

  useEffect(() => {
    wait(() => {
      dispatch(setContinueDisabled(true, 3))
      if (
        selectedSingleCourseGroup?.id ||
        selectedMultipleCourseGroups?.length
      ) {
        dispatch(setContinueDisabled(false, 3))
      }
    })
  }, [dispatch, selectedSingleCourseGroup, selectedMultipleCourseGroups])

  return (
    <>
      <SlideHeader header={title || 'Select a single course group'} />
      <div className='border p-4 mx-auto single-course-container scrollbar'>
        <Search
          placeholder={'Search for a course group...'}
          value={searchValue}
          setValue={setSearchValue}
        />
        <FilterSelectedOnly
          item={selectedSingleCourseGroup}
          items={selectedMultipleCourseGroups}
        />
        {filteredCourseGroups && filteredCourseGroups.length
          ? filteredCourseGroups.map((group) => {
              const isSelected = !multiple
                ? group.id === selectedSingleCourseGroup?.id
                : selectedMultipleCourseGroups
                    ?.map((c) => c?.id)
                    ?.includes(group.id)

              return (
                <div
                  key={group.id}
                  className={`custom-control custom-checkbox mb-3 ${
                    !isSelected && showSelectedOnly && 'd-none'
                  }`}
                  style={{ zIndex: '0' }}
                >
                  <input
                    value={group.id}
                    className='custom-control-input'
                    id={group.id}
                    checked={isSelected}
                    name={group.name}
                    onChange={(e) => {
                      if (!multiple) {
                        if (+e.target.value === selectedSingleCourseGroup?.id) {
                          dispatch(setSingleCourseGroup(null))
                        } else {
                          dispatch(
                            setSingleCourseGroup({
                              id: +e.target.value,
                              name: e.target.name,
                            })
                          )
                        }
                      } else {
                        dispatch(
                          setMultipleCourseGroups({
                            id: group.id,
                            name: group.name,
                          })
                        )
                      }
                    }}
                    type='checkbox'
                  />
                  <label className='custom-control-label' htmlFor={group.id}>
                    {group.name}
                  </label>
                </div>
              )
            })
          : null}
      </div>
    </>
  )
}

export default SelectSingleOrMultipleCourseGroups
